import {
    makeStyles,


} from '@material-ui/core';
import React, {useEffect, useState} from 'react';
import DisclaimerAndUpdateHtmlSubject
    from '../../../znotusedcurrently/rxjs/subjects/disclaimerandupdate/DisclaimerAndUpdateHtmlSubject.jsx2';
import url, { returnWebsocketUrl } from '../../../stores/websocketStore/websocketRoute';
import {observer} from "mobx-react-lite";
import {useWebsocketStore} from "../../../stores/websocketStore/websocketProvider";

const DISCLAIMER_STORAGE_KEY = 'tuAcceptedDisclaimerVersion';

const DisplayDisclaimerAndUpdateHtml = ()=>{//observer(({}) => {
    const {displayDisclaimerAndUpdateHtmlSubject} = useWebsocketStore();
    const [msg, setMsg] = useState('');

    useEffect(() => {
        const subscription = displayDisclaimerAndUpdateHtmlSubject.subscribe(setMsg);
        return () => subscription.unsubscribe();
    }, []);
    return <BuildComponent msg={msg} />;
}//)

export default DisplayDisclaimerAndUpdateHtml;
/*


export default class DisplayDisclaimerAndUpdateHtml1 extends React.Component {
    constructor(props) {
        super(props);
        this.state = {msg: ''};
    }

    componentDidMount() {
        this.subscription = DisclaimerAndUpdateHtmlSubject.subscribe((msg) => {
            this.setState({msg: msg});
        });
    }

    componentWillUnmount() {
        this.subscription.unsubscribe();
    }

    render() {
        return <BuildComponent msg={this.state.msg}/>;
    }
}
*/

function getModalStyle() {
    const top = 50;
    const left = 50;

    return {
        top: `${top}%`,
        left: `${left}%`,
        transform: `translate(-${top}%, -${left}%)`,
    };
}

const useStyles = makeStyles((theme) => ({
    paper: {
        position: 'absolute',
        width: 400,
        backgroundColor: theme.palette.background.paper,
        border: '2px solid #000',
        boxShadow: theme.shadows[5],
        padding: theme.spacing(2, 4, 3),
    },
}));

function BuildComponent({msg}) {
    const classes = useStyles();

    console.log('disclaimerMsg:' + JSON.stringify(msg));
    let acceptedDisclaimer = msg.acceptedDisclaimer;
    let hasSeenLastDisclaimer = msg.hasSeenLastDisclaimer;
    const disclaimerVersion = Number(msg.timeStamp ?? 0);
    let acceptedLocally = false;
    try {
        const storedVersion = window.localStorage.getItem(DISCLAIMER_STORAGE_KEY);
        acceptedLocally =
            storedVersion !== null &&
            (disclaimerVersion <= 0 || storedVersion === String(disclaimerVersion));
    } catch (err) {
        acceptedLocally = false;
    }
    if (acceptedDisclaimer !== undefined && hasSeenLastDisclaimer !== undefined) {
        if ((acceptedDisclaimer && hasSeenLastDisclaimer) || acceptedLocally) {
            if (acceptedDisclaimer && hasSeenLastDisclaimer && disclaimerVersion > 0) {
                try {
                    window.localStorage.setItem(
                        DISCLAIMER_STORAGE_KEY,
                        String(disclaimerVersion)
                    );
                } catch (err) {
                    console.warn('Unable to persist disclaimer acceptance locally', err);
                }
            }
        } else {
            console.log("setting up redirect");
            let redirect =
                window.config && window.config.REACT_APP_REDIRECT
                    ? window.config.REACT_APP_REDIRECT
                    : 'http://localhost:8080/';

            if (redirect !== 'http://localhost:8080/') {
                console.log("redirecting");
                const pathRequest =
                    window?.location?.pathname === '/ui/alerts' ? 'ALERTS_INTERFACE' : 'TU_INTERFACE';
                const websocketUrl = returnWebsocketUrl(pathRequest, 'all');
                const params = new URLSearchParams({
                    websocket: websocketUrl,
                    redirect,
                    disclaimerVersion: String(disclaimerVersion)
                });

                window.location.href = `${redirect}ui/dynamic/disclaimer.html?${params.toString()}`;
            }
        }
    }
    return null;
    //  let updatedUpdate = msg.updatedUpdate;

    //const [modalStyle] = React.useState(getModalStyle);
    //const [openModal, setOpenModal] = useState(false);
    //const [acceptedDisclaimerState, setAcceptedDisclaimer] = useState(
    //  acceptedDisclaimer === undefined ? false : acceptedDisclaimer
    //);

    // useEffect(() => {
    //   setOpenModal(!(acceptedDisclaimer && hasSeenLastDisclaimer));
    //   setAcceptedDisclaimer(
    //     acceptedDisclaimer === undefined ? false : acceptedDisclaimer
    //   );
    // }, [msg]);

    //console.log(openModal);

    //on submit, if dont accept disclaimer log out

    // return (
    //   <>
    //     {/*  <Modal
    //       open={openModal}
    //       //onClose={handleClose}
    //       aria-labelledby="simple-modal-title"
    //       aria-describedby="simple-modal-description"
    //     >
    //       <div style={modalStyle} className={classes.paper}>
    //         <Grid item xs={12}>
    //           disclaimer message
    //         </Grid>
    //         <Grid container>
    //           <Grid item xs={6}>
    //             <FormControlLabel
    //               value="top"
    //               control={
    //                 <StyledCheckbox
    //                   checked={acceptedDisclaimerState}
    //                   onChange={(ev) => {
    //                     setAcceptedDisclaimer(ev.target.checked);
    //                     AcceptDisclaimer(ev.target.checked);
    //                   }}
    //                 />
    //               }
    //               label={
    //                 <Typography style={{ fontSize: 10 }}>
    //                   Accept Disclaimer
    //                 </Typography>
    //               }
    //               labelPlacement="end"
    //             />
    //           </Grid>
    //           <Grid item xs={6}>
    //             <Button
    //               variant="outlined"
    //               onClick={(ev) => {
    //                 SeenDisclaimer(true);
    //               }}
    //             >
    //               <Typography style={{ fontSize: 10 }}>Submit</Typography>
    //             </Button>
    //           </Grid>
    //         </Grid>
    //       </div>
    //     </Modal> */}
    //   </>
    // );
}
